import { observer } from 'mobx-react-lite';
import { FC, PropsWithChildren } from 'react';

import { MessageViewPageType } from 'APP/main/ChatView/Messages/Messages.types';
import type { ChatMessage } from 'STORE/Messages/Message/ChatMessage/ChatMessage';

import { MessageLayout } from '../../MessageLayout/MessageLayout';
import { SenderName } from '../components/SenderName/SenderName';
import StatusBar from '../components/StatusBar';
import styles from './UnsupportedBubble.styles.m.css';

interface IUnsupportedBubbleProps {
  message: ChatMessage;
  messageViewPageType: MessageViewPageType;
  isView: boolean;
}

export const UnsupportedBubble: FC<PropsWithChildren<IUnsupportedBubbleProps>> = observer(
  (props) => {
    const { message, children, messageViewPageType, isView } = props;

    return (
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      <MessageLayout
        message={message}
        className={styles.bubble}
        messageViewPageType={messageViewPageType}
        isView={isView}
        hasActions={false}
      >
        <SenderName
          message={message}
          className={styles.senderName}
        />
        <div
          className={styles.content}
          data-test="text-message"
        >
          {children}
          <StatusBar
            className={styles.statusBar}
            message={message}
          />
        </div>
      </MessageLayout>
    );
  }
);
